import React from "react";
import {
  QueryFPAnalysisData,
  SubscribeFPAnalysisData,
} from "../../../utils/graphql/hooks/fpAnalysisHooks";

export default function FPAnalysisDataManager() {
  QueryFPAnalysisData();
  SubscribeFPAnalysisData();
  return <></>;
}
